module.exports = __webpack_public_path__ + "img/soscardio_footer.bfc4dae6.png";